import {
  StyleSheet,
  Text,
  View,
  SafeAreaView,
  Image,
  TextInput,
  TouchableOpacity,
  KeyboardAvoidingView,
  Dimensions,
  Button,
  ImageBackground,
  ScrollView,
} from "react-native";
import React, { useState, useRef, useEffect } from "react";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
// import { useTranslation } from "react-i18next";
import Appstyles from "../../Constants/AppStyles";
// import OTPTextInput from "react-native-otp-textinput";
import AppColors from "../../Constants/AppColors";
const ForgotPassword = ({ navigation }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonColor, setButtonColor] = useState("#8F430080");
  // const { t } = useTranslation(["common"]);

  const validateForm = () => {
    if (!emailRegex.test(emailOrPhone)) {
      setErrorMessage("Invalid email address.");
      setButtonColor("#8F430080"); // Reset button color
    } else {
      setErrorMessage(""); // Clear error message
      setButtonColor("#9C4900");
      // Rest of your logic for handling the login process...
    }
  };
  const handlePress = () => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback to home or custom action
      window.location.href = "/";
    }
  };
  return (
    <ScrollView
      contentContainerStyle={{ flexGrow: 1, flexDirection: "column" }}
    >
      <SafeAreaView style={Appstyles.LoginContainer}>
        {/* <Text>{t("common:translation.menucard")}</Text> */}

        <View style={{}}>
          <ImageBackground
            source={AppImages.VehicleLogin}
            style={Appstyles.VehicleLoginImage}
          >
            <TouchableOpacity onPress={handlePress}>
              <Image
                source={AppImages.WhiteRoundBack}
                style={{ width: 62, height: 62, resizeMode: "contain" }}
              />
            </TouchableOpacity>
          </ImageBackground>
          <Image source={AppImages.LoginLogo} style={Appstyles.VehicleLogo} />
          <View style={{ marginTop: 40 }}>
            <View
              style={{
                borderBottomColor: "#ACACAC",
                borderBottomWidth: 0.5,
                marginHorizontal: 20,
              }}
            >
              <Text
                style={[
                  Appstyles.EmailidTxt,
                  {
                    textAlign: "center",
                    fontSize: 20,
                    fontStyle: AppFonts.OverpassSemiBold,
                    marginBottom: 10,
                  },
                ]}
              >
                Forgot Password?
                {/* {t("common:translation.Forgot Password?")} */}
              </Text>
            </View>

            <View style={{ marginHorizontal: 20 }}>
              <Text
                style={[
                  Appstyles.EmailidTxt,
                  { marginTop: 20, textAlign: "center" },
                ]}
              >
                Enter your e-mail address below to reset your password.
                {/* {t(
                  "common:translation.Enter your e-mail address below to reset your password. "
                )}{" "} */}
              </Text>
            </View>

            <TextInput
              style={[Appstyles.EmailTextinput, { borderColor: "#ACACAC" }]}
              //onChangeText={onChangeNumber}
              // value={number}
              placeholder={"Enter you Email ID "}
              // placeholder={t("common:translation.Enter you Email ID ")}
              placeholderTextColor={AppColors.dualbrown}
              autoFocus={true}
              value={emailOrPhone}
              onChangeText={(text) => {
                setEmailOrPhone(text);
                if (!emailRegex.test(text)) {
                  setErrorMessage("Invalid email address.");
                  setButtonColor("#8F430080"); // Reset button color
                } else {
                  setErrorMessage(""); // Clear error message
                  if (text.length >= 6) {
                    setButtonColor("#9C4900");
                  } else {
                    setButtonColor("#8F430080"); // Reset button color
                  }
                }
              }}
            />
          </View>
        </View>

        {/* <TouchableOpacity
          onPress={() => navigation.navigate("ForgotPasswordNew")}
        >
          <View style={[Appstyles.LoginButton, { marginBottom: 40 }]}>
            <Text style={Appstyles.LoginTxt}>
              {t("common:translation.Recover")}
            </Text>
          </View>
        </TouchableOpacity> */}
        <TouchableOpacity
          onPress={() =>
            buttonColor === "#9C4900" && navigation.navigate("ForgotOtp")
          }
          style={[Appstyles.LoginButton, { backgroundColor: buttonColor }]}
          disabled={buttonColor !== "#9C4900"}
        >
          <Text style={Appstyles.LoginTxt}>
            {/* {t("common:translation.Continue")} */}
            Continue
          </Text>
        </TouchableOpacity>
      </SafeAreaView>
    </ScrollView>
  );
};

export default ForgotPassword;
